import React from 'react';
import './LinkPreview.css';

const LinkPreview = ({ preview, onRemove }) => {
  if (!preview) return null;

  const handleClick = () => {
    window.open(preview.url, '_blank', 'noopener,noreferrer');
  };

  const getDomain = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname.replace('www.', '');
    } catch {
      return url;
    }
  };

  return (
    <div className="link-preview">
      {onRemove && (
        <button className="link-preview-remove" onClick={onRemove} title="Remove preview">
          ×
        </button>
      )}
      <div className="link-preview-content" onClick={handleClick}>
        {preview.image && (
          <div className="link-preview-image">
            <img src={preview.image} alt={preview.title} onError={(e) => e.target.style.display = 'none'} />
          </div>
        )}
        <div className="link-preview-text">
          <div className="link-preview-domain">{getDomain(preview.url)}</div>
          {preview.title && <div className="link-preview-title">{preview.title}</div>}
          {preview.description && (
            <div className="link-preview-description">{preview.description}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LinkPreview;
